import { DispatchRowActions } from 'modules/sales/dispatch/components/DispatchRowActions';
import { CellAlign, CellType, HeadCell } from '@dfl/mui-admin-layout';
import { IDispatch } from 'modules/sales/dispatch/interfaces';
import { createdATColumn } from 'modules/common/constants/common.columns';
import { DISPATCH_PERMISSIONS } from 'modules/sales/dispatch/constants/dispatch.permissions';
import DispatchStateListCell from '../components/Cell/DispatchStateListCell';
import { ReactLink } from '@dfl/react-security';
import { DISPATCH_ROUTE } from './dispatch-route';
import DispatchSubOrderRowActions from '../components/DispatchRowActions/DispatchSubOrderRowActions';
import { DispatchStatusPicker } from '../components/DispatchStatusPicker';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';

export const dispatchNameColumn: HeadCell<IDispatch> = {
  field: 'name',
  headerName: 'dispatch:fields.name',
  disablePadding: false,
  renderCell: (name: string, data?: IDispatch) => (
    <ReactLink
      permissions={DISPATCH_PERMISSIONS.DISPATCH_VIEW}
      to={`${DISPATCH_ROUTE.DETAIL(data?._id as string)}/general/orders`}
      underline='hover'
    >
      {name}
    </ReactLink>
  ),
};

export const dispatchSuborderCountColumn: HeadCell<IDispatch> = {
  field: 'metrics.suborderCount',
  headerName: 'dispatch:fields.metrics.suborderCount',
  type: CellType.NUMBER,
  align: CellAlign.CENTER,
  headerAlign: CellAlign.CENTER,
};

export const dispatchSubordersByRegionColumn: HeadCell<IDispatch> = {
  field: 'metrics.subordersByRegion',
  headerName: 'dispatch:fields.metrics.subordersByRegion',
  component: DispatchStateListCell,
};
export const dispatchMinDateColumn: HeadCell<any> = {
  field: 'startDate',
  headerName: 'dispatch:fields.metrics.minDate',
  type: CellType.DATE,
};

export const dispatchMaxDateColumn: HeadCell<any> = {
  field: 'endDate',
  headerName: 'dispatch:fields.metrics.maxDate',
  type: CellType.DATE,
};

export const dispatchStatusColumn: HeadCell<any> = {
  field: 'status',
  headerName: 'common:status',
  component: DispatchStatusPicker,
  align: CellAlign.CENTER,
  headerAlign: CellAlign.CENTER,
};

export const dispatchActionsColumn: HeadCell<IDispatch> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: DISPATCH_PERMISSIONS.DISPATCH_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: DispatchRowActions,
};

export const dispatchTotalProductColumns: HeadCell<IDispatch> = {
  headerName: 'distributionCenters:distribution.productTotal',
  field: 'metrics.totalProducts',
  type: CellType.NUMBER,
  align: CellAlign.CENTER,
};

export const dispatchDistributionCenterColumn: HeadCell<any> = {
  field: 'distributionCenter.name',
  headerName: 'distributionCenters:name',
  renderCell: (name: string, data?: any) => (
    <AvatarNameCell
      link={`/inventory/distribution-centers/${data?.distributionCenter?._id as string}/general`}
      hideImage
      name={name}
    />
  ),
};

export const dispatchColumns: Array<HeadCell<any>> = [
  dispatchNameColumn,
  dispatchSuborderCountColumn,
  dispatchTotalProductColumns,
  dispatchStatusColumn,
  dispatchDistributionCenterColumn,
  dispatchMinDateColumn,
  createdATColumn,
  dispatchActionsColumn,
];

export const dispatchSubOrderActionsColumn: HeadCell<IDispatch> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: DISPATCH_PERMISSIONS.DISPATCH_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: DispatchSubOrderRowActions,
};

// by details -> tabs -> suborder list
export const dispatchSubOrderColumn = (subOrderColumn: any[]) => [...subOrderColumn, dispatchSubOrderActionsColumn];
